import React, {useState, useEffect} from 'react';
import { addNewMarketName, getAllMarkertName} from '../../api/market';



function AddMarket({setIsVisibleNewMarkert, setMarketDatas}) {
     const [newMarket, setNewMarket] = useState("");



    const submitNewMarket = (event) => {
        event.preventDefault();

        if (!newMarket) {
            alert("Market name is required");
            return;
        }

        const marketData = { name: newMarket };

        addNewMarketName(marketData, (result) => {
            if (result.ok !== 1) {
                console.log(result);
                return;
            }
            alert("New Market added successfully!");
            setIsVisibleNewMarkert(false);
        });
    };
    
    useEffect(() =>{
           getAllMarkertName((result) => {
                      if (result.ok !== 1) {
                          console.log(result);
                          return;
                      }
                      setMarketDatas(result.result);
                  });
    })


    return (
      <form method="post">
          <div className="row">
                                    <label>New Market Name</label>
                                    <div className="col md-9">
                                        <input
                                            name="newMarketName"
                                            onChange={(e) => setNewMarket(e.target.value)}
                                            type="text"
                                            placeholder="New Market Name"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col md-6">
                                        <button className="btn btn-primary btn-sm mt-2" type="button" onClick={submitNewMarket}>
                                            Add
                                        </button>
                                        <button
                                            className="btn btn-danger btn-sm mt-2"
                                            type="button"
                                            onClick={() => setIsVisibleNewMarkert(false)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
      </form>
    );
}

export default AddMarket;